export default "__VITE_ASSET__CQxBhsM6__"